
// Metadata for the armpit pain article
export const armpitPainMetadata = {
  id: "armpit-pain-causes",
  slug: "understanding-armpit-pain",
  title: "10 Common Causes of Armpit Pain: When to Seek Medical Attention",
  excerpt: "Explore the most common causes of armpit pain, from mild irritations to more serious conditions, and learn when to seek medical attention.",
  publishedAt: "April 10, 2023",
  readTime: "10 min read",
  category: "Health",
  image: "/lovable-uploads/3d759755-8ffc-4d2b-bf15-f297029b2ca1.png",
  metaDescription: "Learn about the common causes of armpit pain including skin infections, swollen lymph nodes, muscle strains, and more serious conditions that require medical attention.",
  keywords: ["armpit pain", "underarm pain", "armpit discomfort", "swollen lymph nodes", "hidradenitis suppurativa", "muscle strain", "skin infection", "breast cancer"],
};
